module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-shenzhen.d4ea3e52.webm";